// src/services/leaveTypesService.js
//
// Leave Types API service (thin)
// ==============================
//
// Endpoints assumed (you can adapt paths):
//   GET    /admin/leave-types
//   POST   /admin/leave-types
//   PUT    /admin/leave-types/:id
//   PATCH  /admin/leave-types/:id/active   body: { active: 0|1 }
//
// Uses shared apiClient.

import apiClient from "../utils/apiClient";
import { isRequestCanceled } from "./httpUtils";

export async function fetchLeaveTypes(options = {}) {
  try {
    const res = await apiClient.get("/admin/leave-types", {
      withCredentials: true,
      signal: options.signal,
    });
    return Array.isArray(res.data) ? res.data : (res.data?.rows || []);
  } catch (e) {
    if (isRequestCanceled(e)) throw e;
    console.error("[leaveTypesService] ❌ fetchLeaveTypes failed:", e);
    throw e;
  }
}

export async function createLeaveType(payload) {
  try {
    const res = await apiClient.post("/admin/leave-types", payload, {
      withCredentials: true,
    });
    return res.data;
  } catch (e) {
    if (isRequestCanceled(e)) throw e;
    console.error("[leaveTypesService] ❌ createLeaveType failed:", e);
    throw e;
  }
}

export async function updateLeaveType(id, payload) {
  try {
    const res = await apiClient.put(`/admin/leave-types/${id}`, payload, {
      withCredentials: true,
    });
    return res.data;
  } catch (e) {
    if (isRequestCanceled(e)) throw e;
    console.error("[leaveTypesService] ❌ updateLeaveType failed:", e);
    throw e;
  }
}

export async function toggleLeaveTypeActive(id, active) {
  try {
    const res = await apiClient.patch(
      `/admin/leave-types/${id}/active`,
      { active: active ? 1 : 0 },
      { withCredentials: true }
    );
    return res.data;
  } catch (e) {
    if (isRequestCanceled(e)) throw e;
    console.error("[leaveTypesService] ❌ toggleLeaveTypeActive failed:", e);
    throw e;
  }
}